//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { BusinessObjectType } from '../../../Core/BusinessObjectType';
import DefaultDtoControllerProxy from './DefaultDtoControllerProxy';
import { ITustenaCompanyDTO } from '../../../DTO/ITustenaCompanyDTO';

//element.Name=TustenaCompanyController result.Name=TustenaCompanyController element.FullName=Digita.Tustena.UIApiControllers.BusinessObject.DTO.TustenaCompanyController);
/** WebApiController: TustenaCompanyController */
export class TustenaCompanyController extends DefaultDtoControllerProxy<ITustenaCompanyDTO>
{
	constructor (axios: AxiosInstance)
	{
		super(axios, 'Tiers', BusinessObjectType.TustenaCompany);
	}
	public OrganizationChart(cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<any>
	{
		return (this.axios.get('Tiers/OrganizationChart', { ...axiosConfig, cancelToken })).then(r => r.data);
	}
	public GetFull(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<ITustenaCompanyDTO>
	{
		return (this.axios.get('Tiers/GetFull?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
